// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanRefreshAggregateScores } from "./hook";

export type CanRefreshAggregateScoresProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanRefreshAggregateScores({
  children,
  fallback,
  scope,
}: CanRefreshAggregateScoresProps) {
  const canDoAction = useCanRefreshAggregateScores(scope);
  return <>{canDoAction ? children : fallback}</>;
}
